import * as React from 'react'
import { Grid } from '../components/grid'
import { Link } from '../components/link'
import { Layout } from './layout'

class NotFound extends React.Component {
    render() {
        return (
            <Layout>
                <Grid>
                    <div className='row'>
                        <div className='col-xs-12' style={{ textAlign: 'center', paddingTop: '2rem' }}>
                            <h1 style={{ paddingBottom: '1rem' }}>404 not found</h1>
                            <p>
                                <Link to={'/'}>Go to home page</Link>
                            </p>
                        </div>
                    </div>
                </Grid>
            </Layout>
        )
    }
}

export default NotFound
